import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType
} from 'axios';
import axios from 'axios';

/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** RoleType */
export enum RoleType {
  User = 'user',
  Assistant = 'assistant',
  Tool = 'tool',
  System = 'system'
}

/** RatingType */
export enum RatingType {
  POSITIVE = 'POSITIVE',
  NEUTRAL = 'NEUTRAL',
  NEGATIVE = 'NEGATIVE'
}

/**
 * OpenAIModels
 * Enum for OpenAI models
 */
export enum OpenAIModels {
  Gpt4120250414 = 'gpt-4.1-2025-04-14',
  Gpt4O = 'gpt-4o',
  Gpt4 = 'gpt-4',
  Gpt40613 = 'gpt-4-0613',
  Gpt41106Preview = 'gpt-4-1106-preview',
  Gpt432K = 'gpt-4-32k',
  Gpt432K0613 = 'gpt-4-32k-0613',
  Gpt35Turbo = 'gpt-3.5-turbo',
  Gpt35Turbo1106 = 'gpt-3.5-turbo-1106'
}

/** InsightBlocks */
export enum InsightBlocks {
  Farmboundarydetection = 'farmboundarydetection',
  Cropparameter = 'cropparameter',
  Cropphenology = 'cropphenology',
  Lulc = 'lulc',
  Changedetection = 'changedetection',
  Waterqualityindexmodel = 'waterqualityindexmodel',
  Forestbiomass = 'forestbiomass',
  Cropstress = 'cropstress',
  Cropclassification = 'cropclassification',
  Gapfillndvi = 'gapfillndvi'
}

/** GenerationStatus */
export enum GenerationStatus {
  InProgress = 'in_progress',
  Completed = 'completed',
  Failed = 'failed'
}

/**
 * AvailableSatellites
 * Enum containing list of satellites supported by Seeker
 */
export enum AvailableSatellites {
  Landsat89 = 'Landsat 8-9',
  Sentinel2 = 'Sentinel-2',
  ModisNBARDaily = 'Modis NBAR Daily',
  PixxelTD01 = 'Pixxel-TD01',
  PixxelFirefly = 'Pixxel-Firefly',
  PixxelTD02 = 'Pixxel-TD02',
  Sentinel1RTC = 'Sentinel-1 (RTC)',
  MODISLSTE8Day = 'MODIS LST/E 8-Day',
  MODISSR8Day250M = 'MODIS SR 8-Day 250m',
  EO01Hyperion = 'EO-01 Hyperion',
  Unsupported = 'Unsupported'
}

/**
 * AOIScreenDetails
 * Represents details specific to AOI, asset, and inference visualization on the screen.
 *
 * Note on SerializedUUID: AOIScreenDetails needs a special str-serialized UUID type because of SQLAlchemy. Yes.
 * This is because while pydantic automatically dumps UUIDs to strings before returning, the same is not possible
 * when commit a `model_dump` of this object through SQLAlchemy into postgres. It needs it to be a string. It refuses
 * to automatically stringify the UUID for some reason.
 */
export interface AOIScreenDetails {
  /**
   * Aoi Id
   * AOI ID for the assets currently on the user's screen, if any.
   * @format uuid
   */
  aoi_id: string;
  /**
   * Asset Id
   * Asset ID of the asset that is currently visualized on the user's screen, if any.
   */
  asset_id?: string | null;
  /**
   * Inference Id
   * Inference ID of the insight that is currently visualized on the user's screen, if any.
   */
  inference_id?: string | null;
}

/** ActionStep */
export interface ActionStep {
  /**
   * Role
   * @default "tool"
   */
  role?: 'tool';
  /** Name */
  name: string;
  /** Tool Call Id */
  tool_call_id: string;
  /** Tool Data */
  tool_data:
    | Citations
    | CurrentSearchFilters
    | ImageSearchParameters
    | IndexAgentResponse
    | InsightsHandlerResponse;
  /** @default "completed" */
  generation_status?: GenerationStatus;
}

/** AssistantStep */
export interface AssistantStep {
  /**
   * Role
   * @default "assistant"
   */
  role?: 'assistant';
  /** Content */
  content?: string | null;
  /** Tool Calls */
  tool_calls?: ToolCall[] | null;
  /** @default "NEUTRAL" */
  rating?: RatingType;
  /** @default "in_progress" */
  generation_status?: GenerationStatus;
}

/** Chat */
export interface Chat {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** User Id */
  user_id: string;
  /** Active */
  active: boolean;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Is Locked
   * @default false
   */
  is_locked?: boolean;
  /** Updated At */
  updated_at: string | null;
  /** Name */
  name: string | null;
}

/** ChatFailed */
export interface ChatFailed {
  /**
   * Code
   * @default "chat_failed"
   */
  code?: 'chat_failed';
  /** Message */
  message: string;
  /**
   * Details
   * @default {}
   */
  details?: object;
}

/** ChatInvalidName */
export interface ChatInvalidName {
  /**
   * Code
   * @default "chat_invalid_name"
   */
  code?: 'chat_invalid_name';
  /** Message */
  message: string;
  /**
   * Details
   * @default {}
   */
  details?: object;
}

/** ChatNotFound */
export interface ChatNotFound {
  /**
   * Code
   * @default "chat_not_found"
   */
  code?: 'chat_not_found';
  /** Message */
  message: string;
  /**
   * Details
   * @default {}
   */
  details?: object;
}

/**
 * Citations
 * Contains the list of citations for a given query.
 */
export interface Citations {
  /** Citations */
  citations?: RetrievalResponse[] | null;
  /** Error */
  error?: string | null;
}

/**
 * CurrentSearchFilters
 * Contains the current search filters set in the "explore" user-interface.
 * Results of this tool call will never be returned to the front-end.
 * This is for internal use only.
 * <br><br>
 * It still appears in the OpenAPI spec for certain unavoidable reasons.
 */
export interface CurrentSearchFilters {
  /** Contains variables that can be used to execute a STAC search for satellite imagery */
  explore_filters: ExploreFilters;
}

/** CustomIndex */
export interface CustomIndex {
  /**
   * Name
   * The name of the custom index
   */
  name: string;
  /**
   * Id
   * The ID of the custom index
   */
  id: string;
  /**
   * Description
   * The description of the custom index
   */
  description: string;
  /**
   * Lens Satellite Id
   * The ID of the lens satellite
   */
  lens_satellite_id: string;
  /**
   * Expression
   * The expression of the custom index
   */
  expression: string;
  /**
   * Type
   * The type of the custom index
   */
  type: string;
  /**
   * Bands
   * The bands of the custom index
   */
  bands: string[];
}

/**
 * Error
 * Contains information about issues with the user's prompt
 */
export interface Error {
  /**
   * Is Location Specified
   * True if prompt contains location info
   * @default false
   */
  is_location_specified?: boolean;
  /**
   * Is Time Specified
   * True if prompt contains time info
   * @default false
   */
  is_time_specified?: boolean;
  /**
   * Is Cloud Cover Specified
   * True if prompt contains cloud cover info
   * @default false
   */
  is_cloud_cover_specified?: boolean;
  /**
   * Is Satellite Specified
   * True if prompt contains satellite info
   * @default false
   */
  is_satellite_specified?: boolean;
  /**
   * Is Search Intent
   * True if prompt can be used to search for satellite imagery
   * @default false
   */
  is_search_intent?: boolean;
  /**
   * Is Bbox Valid
   * True if bounding box area is less the threshold.
   * @default true
   */
  is_bbox_valid?: boolean;
}

/** ErrorDetails */
export interface ErrorDetails {
  /** Code */
  code: string;
  /** Message */
  message: string;
  /**
   * Details
   * @default {}
   */
  details?: object;
}

/** ErrorResponse */
export interface ErrorResponse {
  error: ErrorDetails;
}

/** ErrorResponse[ChatFailed] */
export interface ErrorResponseChatFailed {
  error: ChatFailed;
}

/** ErrorResponse[ChatInvalidName] */
export interface ErrorResponseChatInvalidName {
  error: ChatInvalidName;
}

/** ErrorResponse[ChatNotFound] */
export interface ErrorResponseChatNotFound {
  error: ChatNotFound;
}

/** ErrorResponse[MessageAndChatIDMismatch] */
export interface ErrorResponseMessageAndChatIDMismatch {
  error: MessageAndChatIDMismatch;
}

/** ErrorResponse[MessageGenerationInProgress] */
export interface ErrorResponseMessageGenerationInProgress {
  error: MessageGenerationInProgress;
}

/** ErrorResponse[MessageNotFound] */
export interface ErrorResponseMessageNotFound {
  error: MessageNotFound;
}

/** ErrorResponse[TooManyPromptsRequested] */
export interface ErrorResponseTooManyPromptsRequested {
  error: TooManyPromptsRequested;
}

/**
 * ExploreFilters
 * Contains variables that can be used to execute a STAC search for satellite imagery
 */
export interface ExploreFilters {
  /**
   * Satellites
   * List of one or more of ['Landsat 8-9', 'Sentinel-2', 'Modis NBAR Daily', 'Pixxel-TD01', 'Pixxel-Firefly', 'Pixxel-TD02', 'Sentinel-1 (RTC)', 'MODIS LST/E 8-Day', 'MODIS SR 8-Day 250m', 'EO-01 Hyperion', 'Unsupported'], if provided
   */
  satellites?: AvailableSatellites[] | null;
  /**
   * Bbox
   * bbox covering the requested AOI
   */
  bbox?: any[] | null;
  /**
   * Start Time
   * ISO 8601 time range
   */
  start_time?: string | null;
  /**
   * End Time
   * ISO 8601 time range
   */
  end_time?: string | null;
  /**
   * Minimum Cloud Cover
   * [0-100] Minimum cloud cover
   */
  minimum_cloud_cover?: number | null;
  /**
   * Maximum Cloud Cover
   * [0-100] Maximum cloud cover
   */
  maximum_cloud_cover?: number | null;
}

/**
 * FilterState
 * Contains variables that can be used to execute a STAC search for satellite imagery
 */
export interface FilterState {
  /**
   * Satellites
   * List of one or more of ['Landsat 8-9', 'Sentinel-2', 'Modis NBAR Daily', 'Pixxel-TD01', 'Pixxel-Firefly', 'Pixxel-TD02', 'Sentinel-1 (RTC)', 'MODIS LST/E 8-Day', 'MODIS SR 8-Day 250m', 'EO-01 Hyperion', 'Unsupported'], if provided
   */
  satellites?: AvailableSatellites[] | null;
  /**
   * Bbox
   * bbox covering the requested AOI
   */
  bbox?: any[] | null;
  /**
   * Start Day
   * [DD: 1-31] Day of the date to search imagery from
   */
  start_day?: number | null;
  /**
   * Start Month
   * [MM: 1-12] Month of the date to search imagery from
   */
  start_month?: number | null;
  /**
   * Start Year
   * [YYYY] Year of the date to search imagery from
   */
  start_year?: number | null;
  /**
   * End Day
   * [DD: 1-31] Day of the date to search imagery up until
   */
  end_day?: number | null;
  /**
   * End Month
   * [MM: 1-12] Month of the date to search imagery up until
   */
  end_month?: number | null;
  /**
   * End Year
   * [YYYY] Year of the date to search imagery up until
   */
  end_year?: number | null;
  /**
   * Minimum Cloud Cover
   * [0-100] Minimum cloud cover
   */
  minimum_cloud_cover?: number | null;
  /**
   * Maximum Cloud Cover
   * [0-100] Maximum cloud cover
   */
  maximum_cloud_cover?: number | null;
}

/** Function */
export interface Function {
  /**
   * Arguments
   * @default ""
   */
  arguments?: string;
  /** Name */
  name: string;
}

/** HTTPValidationError */
export interface HTTPValidationError {
  /** Detail */
  detail?: ValidationError[];
}

/**
 * ImageSearchParameters
 * Contains the search parameters for satellite imagery search.
 */
export interface ImageSearchParameters {
  /**
   * Satellite Ids
   * @default []
   */
  satellite_ids?: string[];
  explore_filters?: ExploreFilters | null;
  error?: Error | null;
}

/** IndexAgentResponse */
export interface IndexAgentResponse {
  /**
   * Text Response
   * the text response from the agent
   */
  text_response: string;
  /**
   * Indices
   * the list of indices based on the search query
   */
  indices: CustomIndex[];
  /**
   * Aoi Id
   * the aoi id on which the query has been fired by the user
   */
  aoi_id: string;
}

/** InsightsHandlerResponse */
export interface InsightsHandlerResponse {
  /** Aoi Id */
  aoi_id: string | null;
  /** Message */
  message: string;
  /** Blocks */
  blocks: InsightBlocks[];
}

/** Message */
export interface Message {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /**
   * Chat Id
   * @format uuid
   */
  chat_id: string;
  role: RoleType;
  /** Content */
  content: string | null;
  /** Screen Context */
  screen_context: object | null;
  /** Is Complete */
  is_complete: boolean;
  /** Created At */
  created_at: string | null;
}

/** MessageAndChatIDMismatch */
export interface MessageAndChatIDMismatch {
  /**
   * Code
   * @default "message_and_chat_id_mismatch"
   */
  code?: 'message_and_chat_id_mismatch';
  /** Message */
  message: string;
  /**
   * Details
   * @default {}
   */
  details?: object;
}

/** MessageGenerationInProgress */
export interface MessageGenerationInProgress {
  /**
   * Code
   * @default "message_generation_in_progress"
   */
  code?: 'message_generation_in_progress';
  /** Message */
  message: string;
  /**
   * Details
   * @default {}
   */
  details?: object;
}

/** MessageNotFound */
export interface MessageNotFound {
  /**
   * Code
   * @default "message_not_found"
   */
  code?: 'message_not_found';
  /** Message */
  message: string;
  /**
   * Details
   * @default {}
   */
  details?: object;
}

/**
 * Prompt
 * Contains the user's prompt
 */
export interface Prompt {
  /**
   * Text
   * User's search query for geospatial data
   * @default ""
   */
  text?: string;
}

/** PromptsResponse */
export interface PromptsResponse {
  /** Sample Prompts */
  sample_prompts: string[];
}

/** RatingRequest */
export interface RatingRequest {
  rating: RatingType;
}

/** RatingResponse */
export interface RatingResponse {
  rating: RatingType;
}

/** ResponseData */
export interface ResponseDataInput {
  /** Inference Id */
  inference_id: string;
  filter_state: FilterState | null;
}

/** ResponseData */
export interface ResponseDataOutput {
  /** Inference Id */
  inference_id: string;
  filter_state: FilterState | null;
}

/** ResponseTimes */
export interface ResponseTimes {
  /**
   * Response Times
   * @default [0]
   */
  response_times?: number[];
  /**
   * Mean Response Time
   * @default 0
   */
  mean_response_time?: number;
  /**
   * Standard Deviation
   * @default 0
   */
  standard_deviation?: number;
}

export interface GetMessageQuery {
  /** After Message Id */
  after_message_id?: string | null;
}

/** RetrievalResponse */
export interface RetrievalResponse {
  /** Text */
  text: string;
  /** Score */
  score: number;
  /** Url */
  url: string;
}

/**
 * ScreenContext
 * Provides a structure to the front-end to provide screen context to the model.
 * More keys for different screens will be added over time.
 */
export interface ScreenContext {
  /** Values of filters currently set in the explore search UI */
  filter_state?: FilterState | null;
  /** Container with details about assets visualized on the AOI screen */
  aoi_screen?: AOIScreenDetails | null;
}

/**
 * SearchInput
 * Container for the user's prompt, platform context, and inputs that have already been specified
 */
export interface SearchInput {
  /**
   * Contains the user's prompt
   * @default {"text":""}
   */
  prompt?: Prompt;
  /** Current state of imagery search filters on the front-end */
  filter_context?: FilterState;
  /**
   * Filter values that are specified already
   * @default {"is_cloud_cover_specified":false,"is_location_specified":false,"is_satellite_specified":false,"is_time_specified":false}
   */
  specified_inputs?: SpecifiedInputs;
}

/** SeekerResponse */
export interface SeekerResponseInput {
  data: ResponseDataInput;
  error: Error | null;
}

/** SeekerResponse */
export interface SeekerResponseOutput {
  data: ResponseDataOutput;
  error: Error | null;
}

/**
 * SpecifiedInputs
 * Used to specify what all parts of the search query are either inferred by the model or given by the user as manual
 * input already
 */
export interface SpecifiedInputs {
  /**
   * Is Location Specified
   * True if prompt contains location info
   * @default false
   */
  is_location_specified?: boolean;
  /**
   * Is Time Specified
   * True if prompt contains time info
   * @default false
   */
  is_time_specified?: boolean;
  /**
   * Is Cloud Cover Specified
   * True if prompt contains cloud cover info
   * @default false
   */
  is_cloud_cover_specified?: boolean;
  /**
   * Is Satellite Specified
   * True if prompt contains satellite info
   * @default false
   */
  is_satellite_specified?: boolean;
}

/** StepResponse */
export interface StepResponse {
  /**
   * Steps
   * List of system / user / assistant and tool steps.
   * @default []
   */
  steps?: StepWithID[];
  /**
   * Is Finished
   * Indicates whether more steps are being generated at the moment.
   * @default false
   */
  is_finished?: boolean;
}

/** StepWithID */
export interface StepWithID {
  /** Step */
  step:
    | ({
        role: 'assistant';
      } & AssistantStep)
    | ({
        role: 'tool';
      } & ActionStep)
    | ({
        role: 'user';
      } & UserStep);
  /**
   * Id
   * @format uuid
   */
  id: string;
}

/** TooManyPromptsRequested */
export interface TooManyPromptsRequested {
  /**
   * Code
   * @default "too_many_prompts_requested"
   */
  code?: 'too_many_prompts_requested';
  /** Message */
  message: string;
  /**
   * Details
   * @default {}
   */
  details?: object;
}

/** ToolCall */
export interface ToolCall {
  function: Function;
  /** Id */
  id: string;
  /**
   * Type
   * @default "function"
   */
  type?: 'function';
}

/** UpdateChatRequest */
export interface UpdateChatRequest {
  /**
   * Name
   * New name for the chat
   * @minLength 1
   * @maxLength 200
   */
  name: string;
}

/** UserMessage */
export interface UserMessage {
  /** Message */
  message: string;
  /** @default {} */
  screen_context?: ScreenContext;
}

/** UserStep */
export interface UserStep {
  /**
   * Role
   * @default "user"
   */
  role?: 'user';
  /**
   * Content
   * @default ""
   */
  content?: string;
  /** @default "in_progress" */
  generation_status?: GenerationStatus;
}

/** ValidationError */
export interface ValidationError {
  /** Location */
  loc: (string | number)[];
  /** Message */
  msg: string;
  /** Error Type */
  type: string;
}

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  'body' | 'method' | 'query' | 'path'
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = 'application/json',
  JsonApi = 'application/vnd.api+json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain'
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || ''
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {})
      }
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem)
        );
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === 'object'
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === ContentType.Text &&
      body &&
      body !== null &&
      typeof body !== 'string'
    ) {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { 'Content-Type': type } : {})
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path
    });
  };
}

/**
 * @title FastAPI
 * @version 0.1.0
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  metrics = {
    /**
     * No description
     *
     * @name MetricsMetricsGet
     * @summary Metrics
     * @request GET:/metrics
     */
    metricsMetricsGet: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/metrics`,
        method: 'GET',
        format: 'json',
        ...params
      })
  };
  ping = {
    /**
     * No description
     *
     * @name PingPingGet
     * @summary Ping
     * @request GET:/ping
     */
    pingPingGet: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/ping`,
        method: 'GET',
        format: 'json',
        ...params
      })
  };
  health = {
    /**
     * @description Check if all the below external components / services are usable: OpenAI, Retrieval, Database, Dexter, Atlas & Lens This endpoint is intentionally self-contained without trying to introduce new code into other modules for health check purposes.
     *
     * @name HealthHealthGet
     * @summary Health
     * @request GET:/health
     */
    healthHealthGet: (params: RequestParams = {}) =>
      this.request<any, void>({
        path: `/health`,
        method: 'GET',
        format: 'json',
        ...params
      })
  };
  chats = {
    /**
     * @description Creates a new `chat` for the given `user_id` and sets it as the active chat and sets any existing chats for the same user as `inactive`.
     *
     * @tags copilot
     * @name CreateChatChatsPost
     * @summary Create Chat
     * @request POST:/chats
     */
    createChatChatsPost: (params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/chats`,
        method: 'POST',
        format: 'json',
        ...params
      }),

    /**
     * @description Get a paginated list of chats for the authenticated user. Returns chats sorted by most recent activity (updated_at desc). Only returns active chats. **Query Parameters:** - `limit`: Number of items per page (1-100, default: 10) - `offset`: Number of items to skip (default: 0) **Response includes:** - `chats`: Array of chat items with id, name, created_at, updated_at - `pagination`: Pagination metadata with limit, offset, total_count
     *
     * @tags copilot
     * @name ListChatsChatsGet
     * @summary List Chats
     * @request GET:/chats
     */
    listChatsChatsGet: (
      query?: {
        /** Limit */
        limit?: number | null;
        /** Offset */
        offset?: number | null;
      },
      params: RequestParams = {}
    ) =>
      this.request<Chat[], ErrorResponse | HTTPValidationError>({
        path: `/chats`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * @description Get a chat by its ID. If the chat name is empty, uses the first 50 characters of the first message as the name.
     *
     * @tags copilot
     * @name GetChatByIdChatsIdGet
     * @summary Get Chat By Id
     * @request GET:/chats/{id}
     */
    getChatByIdChatsIdGet: (id: string, params: RequestParams = {}) =>
      this.request<
        Chat,
        ErrorResponseChatNotFound | ErrorResponseChatFailed | ErrorResponse
      >({
        path: `/chats/${id}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * @description Update a chat's name. Only the owner can rename their active chats. The name must be non-null and under 200 characters after trimming whitespace.
     *
     * @tags copilot
     * @name UpdateChatChatsChatIdPatch
     * @summary Update Chat
     * @request PATCH:/chats/{chat_id}
     */
    updateChatChatsChatIdPatch: (
      chatId: string,
      data: UpdateChatRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        Chat,
        | ErrorResponseChatInvalidName
        | ErrorResponseChatNotFound
        | ErrorResponseChatFailed
        | ErrorResponse
      >({
        path: `/chats/${chatId}`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Delete a chat by marking it as inactive (soft delete). Only the chat owner can delete their own active chats. Deleted chats don't appear in default chat lists but all messages are preserved.
     *
     * @tags copilot
     * @name DeleteChatChatsChatIdDelete
     * @summary Delete Chat
     * @request DELETE:/chats/{chat_id}
     */
    deleteChatChatsChatIdDelete: (chatId: string, params: RequestParams = {}) =>
      this.request<
        any,
        ErrorResponseChatNotFound | HTTPValidationError | ErrorResponse
      >({
        path: `/chats/${chatId}`,
        method: 'DELETE',
        format: 'json',
        ...params
      }),

    /**
     * @description Adds a new message to the given `chat_id`. Raises a `404` if the chat is not found. Raises a `409` if a response is already being generated.
     *
     * @tags copilot
     * @name AddMessageChatsChatIdMessagesPost
     * @summary Add Message
     * @request POST:/chats/{chat_id}/messages
     */
    addMessageChatsChatIdMessagesPost: (
      chatId: string,
      data: UserMessage,
      params: RequestParams = {}
    ) =>
      this.request<
        any,
        | ErrorResponseChatNotFound
        | ErrorResponseMessageGenerationInProgress
        | ErrorResponseChatFailed
      >({
        path: `/chats/${chatId}/messages`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags copilot
     * @name GetMessagesChatsChatIdMessagesGet
     * @summary Get Messages
     * @request GET:/chats/{chat_id}/messages
     */
    getMessagesChatsChatIdMessagesGet: (
      chatId: string,
      query?: {
        /** After Message Id */
        after_message_id?: string | null;
      },
      params: RequestParams = {}
    ) =>
      this.request<
        StepResponse,
        | (ErrorResponseChatNotFound | ErrorResponseMessageNotFound)
        | HTTPValidationError
        | ErrorResponseChatFailed
      >({
        path: `/chats/${chatId}/messages`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * @description Sets rating for the given `chat_id/message_id`.<br> Raises a `404` if the message is not found.<br>
     *
     * @tags copilot
     * @name GiveRatingChatsChatIdMessagesMessageIdRatingPut
     * @summary Give Rating
     * @request PUT:/chats/{chat_id}/messages/{message_id}/rating
     */
    giveRatingChatsChatIdMessagesMessageIdRatingPut: (
      chatId: string,
      messageId: string,
      data: RatingRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        any,
        | (
            | ErrorResponseChatNotFound
            | ErrorResponseMessageNotFound
            | ErrorResponseMessageAndChatIDMismatch
          )
        | ErrorResponseMessageGenerationInProgress
        | HTTPValidationError
      >({
        path: `/chats/${chatId}/messages/${messageId}/rating`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Deletes the last failed assistant+user messages so the user can revise their prompt, clears the chat's failed flag, then re-runs the assistant on the new user message.
     *
     * @tags copilot
     * @name RegenerateResponseChatsChatIdMessagesMessageIdRetryPost
     * @summary Regenerate Response
     * @request POST:/chats/{chat_id}/messages/{message_id}/retry
     */
    regenerateResponseChatsChatIdMessagesMessageIdRetryPost: (
      chatId: string,
      messageId: string,
      data: UserMessage,
      params: RequestParams = {}
    ) =>
      this.request<
        any,
        | (
            | ErrorResponseChatNotFound
            | ErrorResponseMessageNotFound
            | ErrorResponseMessageAndChatIDMismatch
          )
        | ErrorResponseMessageGenerationInProgress
        | ErrorResponseChatFailed
      >({
        path: `/chats/${chatId}/messages/${messageId}/retry`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      })
  };
  chat = {
    /**
     * @description Gets rating for the given `chat_id/message_id`.<br> Raises a `404` if the message is not found.<br>
     *
     * @tags copilot
     * @name GetRatingChatChatIdMessagesMessageIdRatingGet
     * @summary Get Rating
     * @request GET:/chat/{chat_id}/messages/{message_id}/rating
     */
    getRatingChatChatIdMessagesMessageIdRatingGet: (
      chatId: string,
      messageId: string,
      params: RequestParams = {}
    ) =>
      this.request<
        RatingResponse,
        | (
            | ErrorResponseChatNotFound
            | ErrorResponseMessageNotFound
            | ErrorResponseMessageAndChatIDMismatch
          )
        | ErrorResponseMessageGenerationInProgress
        | HTTPValidationError
      >({
        path: `/chat/${chatId}/messages/${messageId}/rating`,
        method: 'GET',
        format: 'json',
        ...params
      })
  };
  prompts = {
    /**
     * @description Returns N random sample prompts to show the user.
     *
     * @tags copilot
     * @name GetPromptsPromptsGet
     * @summary Get Prompts
     * @request GET:/prompts
     */
    getPromptsPromptsGet: (
      query?: {
        /**
         * N
         * @default 6
         */
        n?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<
        PromptsResponse,
        ErrorResponseTooManyPromptsRequested | HTTPValidationError
      >({
        path: `/prompts`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      })
  };
  seeker = {
    /**
     * @description Main entry point into the Seeker app. Returns the results from user's inputs :param search_input: User input :return: Inference results
     *
     * @tags seeker
     * @name SearchSeekerSearchPost
     * @summary Search
     * @request POST:/seeker/search
     */
    searchSeekerSearchPost: (data: SearchInput, params: RequestParams = {}) =>
      this.request<
        SeekerResponseInput,
        SeekerResponseInput | HTTPValidationError
      >({
        path: `/seeker/search`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Entrypoint which takes just text for convenience during development time :param user_prompt: user prompt :return: inference results
     *
     * @tags seeker
     * @name SearchTextSeekerInternalSearchTextPost
     * @summary Search Text
     * @request POST:/seeker/internal/search_text
     */
    searchTextSeekerInternalSearchTextPost: (
      query: {
        /** User Prompt */
        user_prompt: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<
        SeekerResponseInput,
        SeekerResponseInput | HTTPValidationError
      >({
        path: `/seeker/internal/search_text`,
        method: 'POST',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * @description this is an internal endpoint meant for demos only. It returns more human friendly outputs :param user_prompt: user prompt :return: inference results
     *
     * @tags seeker
     * @name SearchWithPrettyOutputSeekerInternalSearchWithPrettyOutputPost
     * @summary Search With Pretty Output
     * @request POST:/seeker/internal/search_with_pretty_output
     */
    searchWithPrettyOutputSeekerInternalSearchWithPrettyOutputPost: (
      query: {
        /** User Prompt */
        user_prompt: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/seeker/internal/search_with_pretty_output`,
        method: 'POST',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * @description This is an internal endpoint meant for profiling only. It runs the user_prompt `n` times through Seeker and allows to optionally override the backend (LLM) OpenAI model using `model` :param user_prompt: :param n: :param model: :return:
     *
     * @tags seeker
     * @name ProfileSeekerSeekerInternalProfilePost
     * @summary Profile Seeker
     * @request POST:/seeker/internal/profile
     */
    profileSeekerSeekerInternalProfilePost: (
      query: {
        /** User Prompt */
        user_prompt: string;
        /**
         * N
         * @default 1
         */
        n?: number;
        /** Model */
        model?: OpenAIModels | null;
      },
      params: RequestParams = {}
    ) =>
      this.request<ResponseTimes, HTTPValidationError>({
        path: `/seeker/internal/profile`,
        method: 'POST',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags seeker
     * @name SubmitFeedbackSeekerSubmitFeedbackPost
     * @summary Submit Feedback
     * @request POST:/seeker/submit_feedback
     */
    submitFeedbackSeekerSubmitFeedbackPost: (
      query: {
        /** Inference Id */
        inference_id: string;
        /** Is Response Relevant */
        is_response_relevant: boolean;
      },
      params: RequestParams = {}
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/seeker/submit_feedback`,
        method: 'POST',
        query: query,
        format: 'json',
        ...params
      })
  };
}
